<template>
  <div>
    <section id="hero">
      <v-row no-gutters>
        <v-img
          :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
          src="@/assets/firstPage.jpeg"
        >
      
          <v-theme-provider dark>
            <v-container fill-height>
              <v-row
                align="center"
                class="white--text mx-auto"
                justify="center"
              >
                <v-col align="center" justify="center"  class="gray--text " cols="12" tag="h1">
                  <span
                  style="font-family:BKoodakBold !important;"
                    :class="[
                      $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2'
                    ]"
                    class="font-weight-light "
                     v-text="$t('company')"
                  >
                  
                  
                  </span>

                  <br />
                    <span>
                        <img  src="@/assets/blueLogo.png" height="30%" width="30%"/>
                    </span>
                    
                
                   <br />
                  <span
                    :class="[
                      $vuetify.breakpoint.smAndDown ? 'display-5' : 'display-6'
                    ]"
                    class="font-weight-light"
                    v-text="$t('wellcome')"
                  >
                   
                  </span>
                </v-col>

                <v-btn
                  class="align-self-end "
                  fab
                  outlined
                  @click="$vuetify.goTo('#about-me')"
                >
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row>
    </section>

    <section id="about-me">
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3" v-text="$t('aboutUsTitle')"></h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-responsive
            align="right"
            :style="$i18n.locale == 'en'?'text-align: left;':'' "
          class="mx-auto title font-weight-light mb-8"
          max-width="720"
          v-text="$t('summaryAboutUs')"
        >
  </v-responsive>
  <v-btn v-text="$t('moreAboutUsTitle')" to="pages/aboutus"></v-btn>

      </v-container>
    </section>
     <v-parallax
        :height="$vuetify.breakpoint.smAndDown ? 350 : 250"
        src="@/assets/parallax.jpeg"
      >
        
      </v-parallax>

    <section id="features" >
      <div class="py-12"></div>

      <v-container  class="text-center">
        <h2 class="display-2 font-weight-bold mb-3" v-text="$t('facilities')"></h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col
            v-for="({ icon, title, text }, i) in features"
            :key="i"
            cols="12"
            md="4"
          >
            <v-card style=" background-image: linear-gradient(blue,white ) !important;" class="py-12 px-4"  flat>
              <v-theme-provider >
                <div>
                  <v-avatar  size="88">
                    <v-icon large v-text="icon"></v-icon>
                  </v-avatar>
                </div>
              </v-theme-provider>

              <v-card-title
                class="justify-center font-weight-black text-uppercase"
                v-text="$t(title)"
              ></v-card-title>

              <v-card-text class="subtitle-1" v-text="$t(text)"> </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>

    <section id="stats">
      <v-parallax
        :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
        src="@/assets/middlePage.jpg"
      >
        <v-container fill-height>
          <v-row class="mx-auto">
            <v-col
              v-for="[value, title] of stats"
              :key="title"
              cols="12"
              md="4"
            >
              <div class="text-center">
                <div
                  class="display-3 font-weight-black mb-4"
                  v-text="value"
                ></div>

                <div
                  class="title font-weight-regular text-uppercase"
                   v-text="$t(title)"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    </section>

    <section id="blog">
      <div class="py-12"></div>

      <v-container>
        <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center" v-text='$t("blog")'>
        </h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col
            v-for="({ src, text, title }, i) in articles"
            :key="i"
            cols="12"
            md="4"
          >
            <v-img
              :src="src"
              class="mb-4"
              height="275"
              max-width="100%"
            ></v-img>

            <h3
              class="font-weight-black mb-4 text-uppercase"
              v-text="title"
            ></h3>

            <div class="title font-weight-light mb-5" v-text="text"></div>

            <v-btn class="ml-n4 font-weight-black" text v-text='$t("continueReading")'>
              
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>

    <v-sheet id="contact" color="transparent" dark tag="section" tile>
      <div class="py-12"></div>

      <v-container>
        <h2 class="display-2  font-weight-bold mb-3 text-uppercase text-center" v-text='$t("contactMe")'>
          
        </h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-theme-provider light>
          <v-row>
            <!--<v-col cols="12">
              <v-text-field v-model="ContactUs.To" flat :label='"*"+$t("name")' solo></v-text-field>
            </v-col>-->

            <v-col cols="12">
              <v-text-field v-model="ContactUs.Email" flat :label='"*"+$t("email")' solo></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field v-model="ContactUs.Subject" flat :label='"*"+$t("subject")' solo></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea v-model="ContactUs.Body" flat :label='"*"+$t("message")' solo></v-textarea>
            </v-col>

            <v-col class="mx-auto" cols="auto">
              <v-btn @click="sendContactUs" color="primary" x-large v-text='$t("send")'>
                
              </v-btn>
            </v-col>
          </v-row>
        </v-theme-provider>
      </v-container>

      <div class="py-12"></div>
    </v-sheet>
  </div>
</template>

<script>
import api from "../../components/api/API";
export default {
  name: "MainPage",
      methods: {
        sendContactUs(){
          debugger;
          api.actions.ftaAction.sendEmail(this.ContactUs).then(data=>{
            if (data) {
              alert(data);
            }
          }).catch(error=>alert(error));
        }
      },
      data () {
      return {
        ContactUs:{
          To:'amirhosseinzarif@gmail.com',
           Subject:'',
            Body:'',
             Email:'',
        },
        articles: [
          {
            src: 'https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80',
            title: 'ويژگي هاي بسته بندي مطلوب',
            text: 'Phasellus lorem enim, luctus ut velit eget, convallis egestas eros. Sed ornare ligula eget tortor tempor, quis porta tellus dictum.',
          },
          {
            src: 'https://images.unsplash.com/photo-1475938476802-32a7e851dad1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80',
            title: 'تاریخچه بسته بندی',
            text: 'Nam ut leo ipsum. Maecenas pretium aliquam feugiat. Aenean vel tempor est, vitae tincidunt risus. Sed sodales vestibulum nibh.',
          },
          {
            src: 'https://images.unsplash.com/photo-1416339442236-8ceb164046f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1892&q=80',
            title: 'هدف از بسته بندی چیست؟',
            text: 'Vestibulum in dictum velit, in rhoncus nibh. Maecenas neque libero, interdum a dignissim in, aliquet vitae lectus. Phasellus lorem enim, luctus ut velit eget.',
          },
           {
            src: 'https://images.unsplash.com/photo-1416339442236-8ceb164046f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1892&q=80',
            title: 'ضرورت نیاز به بسته بندی چیست؟',
            text: 'Vestibulum in dictum velit, in rhoncus nibh. Maecenas neque libero, interdum a dignissim in, aliquet vitae lectus. Phasellus lorem enim, luctus ut velit eget.',
          },
        ],
        features: [
          {
            icon: 'mdi-account-group-outline',
            title: 'support',
            text: 'safeDescription',
          },
          {
            icon: 'mdi-update',
            title: 'material',
            text: 'materialDescription',
          },
          {
            icon: 'mdi-shield-outline',
            title: 'safe',
            text: 'supportDescription',
          },
        ],
        stats: [
          ['7', 'product'],
          ['3+', 'stores'],
          ['1m', 'customers'],
          
        ],
      }
    }
};
</script>
